import { gql } from "@apollo/client";

export const GET_COMBO_RI = gql`
    query getComboRI($campo: String!) {
        comboRI(campo: $campo) {
            comboRIValor {
                idComboRIValor
                valor
            }
        }
    }
`;

export const adaptComboRI = (combo) => {
  return {
    id: combo?.idComboRIValor,
    displayName: combo?.valor
  };
};

export const adaptRadioComboRI = (option) => {
  return {
    value: option?.idComboRIValor,
    label: option?.valor
  };
};

export const adaptCombosRIArray = (data) => {
  return structuredClone(data?.comboRI?.comboRIValor).map((comboValor) => adaptComboRI(comboValor));
};

export const adaptRadioCombosRIArray = (data) => {
  return structuredClone(data?.comboRI?.comboRIValor).map((combo) => adaptRadioComboRI(combo));
};